/**
 * Standard list/pagination contract for every collection endpoint on /api/v1.
 *
 * Pagination is offset-based in v1 (page + pageSize). Responses always include
 * total counts so the UI can render pagers without extra round-trips.
 */
/**
 * Rows per page for every list view. 50 keeps payloads and DOM size comfortable while
 * halving the paging users have to do; list endpoints that add computed columns batch
 * their aggregates per page, so the cost scales linearly rather than per row.
 */
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
/** Clamp a requested pageSize into the allowed range. */
export function clampPageSize(requested) {
    if (!requested || requested < 1)
        return DEFAULT_PAGE_SIZE;
    return Math.min(requested, MAX_PAGE_SIZE);
}
/** Normalize a requested page into a >=1 integer. */
export function normalizePage(requested) {
    if (!requested || requested < 1)
        return 1;
    return Math.floor(requested);
}
//# sourceMappingURL=pagination.js.map